import { render, staticRenderFns } from "./YoungApprentice.vue?vue&type=template&id=0d284805"
import script from "./YoungApprentice.vue?vue&type=script&lang=js"
export * from "./YoungApprentice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports